<template>
  <div
    class="hc-banner home-border"
    :class="[bannerDrawerStatus ? 'success' : '', errorStatus ? 'error' : '']"
    @click="toggleOpen"
  >
    <div v-if="bannerList.length">
      <el-carousel
        :interval="3000"
        :arrow="bannerList.length === 1 ? 'never' : 'always'"
        ref="carousel"
        @change="changeCarousel"
        :class="bannerList.length === 1 ? 'hide' : ''"
        trigger="click"
        :indicator-position="bannerList.length === 2 ? 'none' : 'outside'"
      >
        <el-carousel-item
          v-for="item in bannerList"
          :key="item.id"
          :style="{ 'background-image': `url(${item.url})` }"
        >
        </el-carousel-item>
        <div v-if="bannerList.length === 2">
          <el-carousel-item
            class="carouselItem"
            v-for="item in bannerList"
            :key="item.id"
            :style="{ 'background-image': `url(${item.url})` }"
          >
          </el-carousel-item>
        </div>
      </el-carousel>
      <!--当只有两项时显示自定义的指示器-->
      <ul
        class="
          el-carousel__indicators
          el-carousel__indicators--horizontal
          el-carousel__indicators--outside
        "
        v-if="bannerList.length === 2"
      >
        <li
          :class="index === indexActive ? 'is-active' : ''"
          class="el-carousel__indicator el-carousel__indicator--horizontal"
          v-for="(group, index) in bannerList"
          :key="index"
          @click="handleCarousel(index)"
        >
          <!-- //点击指示器，切换幻灯片的索引 -->
          <button class="el-carousel__button"></button>
        </li>
      </ul>
    </div>
    <!--轮播图可配置1-3张图片-->
    <div class="default-banner" v-else style="height: 284px">
      <defaultContent
        :text="'轮播图可配置1-3张图片'"
        :fontSize="'137px'"
        style="background: linear-gradient(180deg, #deb9fb 0%, #ba83f5 100%)"
      />
    </div>

    <!-- <drawer-banner
      :status="bannerDrawerStatus"
      :list="bannerList"
      @error="error"
      @close="close"
      @remove="remove"
      ref="drawerBanner"
    /> -->
    <common-template
      :status="bannerDrawerStatus"
      :maxLen="maxLen"
      :list="bannerList"
      @error="error"
      @close="close"
      @editData="editData"
      @remove="remove"
      ref="drawerBanner"
      :submitText="'轮播图'"
    >
      <div class="draw-title" slot="info">
        <h3>轮播图</h3>
        <p>轮播图至多可配置3张，图片、链接 均为必填项</p>
        <p>图片建议尺寸: 664 * 284</p>
      </div>
    </common-template>
  </div>
</template>

<script>
import defaultContent from "../defaultContent.vue";
// import DrawerBanner from "./drawerBanner.vue";
import { Home } from "@/config/axios/new_api";
import CommonTemplate from "../commonTemplate.vue";
//HomeSetting
export default {
  components: { defaultContent, CommonTemplate },
  data() {
    return {
      bannerDrawerStatus: false,
      errorStatus: false,
      bannerList: [],
      maxLen: 3,
      indexActive: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    changeCarousel(a) {
      if (this.bannerList.length === 2) {
        a === 2
          ? (this.indexActive = 0)
          : a === 3
          ? (this.indexActive = 1)
          : (this.indexActive = a);
      } else {
        this.indexActive = a;
      }
    },
    async getData() {
      Home.getData({ type: 1, random: Math.random() }).then((res) => {
        if (Array.isArray(res.data)) {
          this.bannerList = res.data.map((item) => {
            item.name_edit_status = false;
            item.directories_name = item.directories_id ? item.file_name : "";
            item.template_name = item.template_id ? item.file_name : "";
            return item;
          });
        }
      });
    },
    remove(newItems) {
      this.bannerList = newItems;
    },
    editData(newItems, index) {
      this.$set(this.bannerList, index, newItems);
    },
    handleCarousel(index) {
      this.$refs.carousel.setActiveItem(index);
    },
    close() {
      this.bannerDrawerStatus = false;
      // 关闭的时候判断数据 如果全部都存在 就需要把红框去掉
      if (this.bannerList.length < 1) {
        this.errorStatus = true;
        this.$message.error("轮播图最少需要配置1张");
      } else {
        let list = this.bannerList.filter((item) => {
          if (
            item.url &&
            item.img_name &&
            ((item.path_type === 1 && item.directories_id) ||
              (item.path_type && item.template_id))
          ) {
            return item;
          }
        });

        if (list.length < this.bannerList.length) {
          this.$refs.drawerBanner.save();
          this.errorStatus = true;
        } else {
          this.$refs.drawerBanner.save();
          this.errorStatus = false;
        }
      }
    },
    error(status) {
      // 提交错误信息 需要在轮播图画红线
      this.errorStatus = status;
    },
    submit() {
      this.$refs.drawerBanner.save();
    },
    toggleOpen() {
      this.bannerDrawerStatus = true;
    },
  },
};
</script>
<style lang="scss">
.hc-banner {
  width: 664px;
  height: 304px;
  float: left;
  cursor: pointer;
  padding: 10px;
  position: relative;
  // border: 1px solid red;
  background-size: 100% 100%;
  .el-carousel__container {
    height: 284px;
    border-radius: 12px;
    overflow: hidden;
  }
  .el-carousel__indicators {
    position: absolute !important;
    width: 100%;
    left: 0;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
.el-carousel__item {
  background-size: 100% 100%;
  background-position: center;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
